export const data = [
  {
    "id": "japan",
    "color": "hsl(55, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 10
      },
      {
        "x": "helicopter",
        "y": 276
      },
      {
        "x": "boat",
        "y": 140
      },
      {
        "x": "train",
        "y": 59
      },
      {
        "x": "subway",
        "y": 186
      },
      {
        "x": "bus",
        "y": 231
      },
      {
        "x": "car",
        "y": 265
      },
      {
        "x": "moto",
        "y": 213
      },
      {
        "x": "bicycle",
        "y": 246
      },
      {
        "x": "horse",
        "y": 13
      },
      {
        "x": "skateboard",
        "y": 285
      },
      {
        "x": "others",
        "y": 281
      }
    ]
  },
  {
    "id": "france",
    "color": "hsl(320, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 276
      },
      {
        "x": "helicopter",
        "y": 88
      },
      {
        "x": "boat",
        "y": 282
      },
      {
        "x": "train",
        "y": 177
      },
      {
        "x": "subway",
        "y": 130
      },
      {
        "x": "bus",
        "y": 252
      },
      {
        "x": "car",
        "y": 274
      },
      {
        "x": "moto",
        "y": 243
      },
      {
        "x": "bicycle",
        "y": 60
      },
      {
        "x": "horse",
        "y": 137
      },
      {
        "x": "skateboard",
        "y": 217
      },
      {
        "x": "others",
        "y": 27
      }
    ]
  },
  {
    "id": "us",
    "color": "hsl(321, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 122
      },
      {
        "x": "helicopter",
        "y": 113
      },
      {
        "x": "boat",
        "y": 58
      },
      {
        "x": "train",
        "y": 103
      },
      {
        "x": "subway",
        "y": 275
      },
      {
        "x": "bus",
        "y": 119
      },
      {
        "x": "car",
        "y": 138
      },
      {
        "x": "moto",
        "y": 276
      },
      {
        "x": "bicycle",
        "y": 65
      },
      {
        "x": "horse",
        "y": 126
      },
      {
        "x": "skateboard",
        "y": 194
      },
      {
        "x": "others",
        "y": 283
      }
    ]
  },
  {
    "id": "germany",
    "color": "hsl(276, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 219
      },
      {
        "x": "helicopter",
        "y": 299
      },
      {
        "x": "boat",
        "y": 136
      },
      {
        "x": "train",
        "y": 278
      },
      {
        "x": "subway",
        "y": 22
      },
      {
        "x": "bus",
        "y": 255
      },
      {
        "x": "car",
        "y": 115
      },
      {
        "x": "moto",
        "y": 9
      },
      {
        "x": "bicycle",
        "y": 229
      },
      {
        "x": "horse",
        "y": 252
      },
      {
        "x": "skateboard",
        "y": 165
      },
      {
        "x": "others",
        "y": 78
      }
    ]
  },
  {
    "id": "norway",
    "color": "hsl(349, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 287
      },
      {
        "x": "helicopter",
        "y": 83
      },
      {
        "x": "boat",
        "y": 204
      },
      {
        "x": "train",
        "y": 173
      },
      {
        "x": "subway",
        "y": 101
      },
      {
        "x": "bus",
        "y": 138
      },
      {
        "x": "car",
        "y": 85
      },
      {
        "x": "moto",
        "y": 147
      },
      {
        "x": "bicycle",
        "y": 123
      },
      {
        "x": "horse",
        "y": 148
      },
      {
        "x": "skateboard",
        "y": 78
      },
      {
        "x": "others",
        "y": 196
      }
    ]
  }
]